import { componentOutletConfigFactory } from '@recruitee/common';
import { injectTranslate } from '@recruitee/i18n';
import { EMPTY_CELL, TextCellComponent } from '@recruitee/user-interface';

import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';
import { defineOfferTableColumn } from './utils';

export const hiredCountColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.HiredCandidatesCount,
  label: injectTranslate()('app.offers.table.hired_candidates_count'),
  visible: true,
  geometry: {
    width: 130,
    minWidth: 130,
    maxWidth: 130,
  },
  options: {
    draggable: false,
    resizable: false,
    removable: true,
    sortable: false,
  },
  componentFactory: ({ row }) => {
    const { numberOfOpenings, hiredCandidatesCount } = row;
    const className = OfferColumnId.HiredCandidatesCount;
    if (typeof hiredCandidatesCount === 'number' && typeof numberOfOpenings === 'number') {
      return componentOutletConfigFactory(TextCellComponent, {
        inputs: {
          class: className,
          value: `${hiredCandidatesCount} / ${numberOfOpenings}`,
        },
      });
    } else if (typeof hiredCandidatesCount !== null && typeof numberOfOpenings !== undefined) {
      return componentOutletConfigFactory(TextCellComponent, {
        inputs: {
          class: className,
          value: hiredCandidatesCount,
        },
      });
    } else {
      return EMPTY_CELL;
    }
  },
}));
